import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import CaseName from './CaseName';
import { fetchFormIfNeeded } from '../actions/form';
import {
  fetchCustomers,
  selectCustomer,
  createdCustomer,
} from '../actions/customers';
import { getCustomers } from '../reducers/customers';
import { getForm } from '../reducers/form';
import { CustomerSelector } from './CustomerSelector';
import SiteSelector from './SiteSelector';
import ContactSelector from './ContactSelector';

const mapStateToProps = (state, ownProps) => ({
  customers: getCustomers(state),
  form: getForm(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  fetchCustomers: () => dispatch(fetchCustomers()),
  selectCustomer: customerId => dispatch(selectCustomer(customerId)),
  onCustomerCreated: customer => dispatch(createdCustomer(customer)),
});

export class Page extends React.Component {
  componentWillMount() {
    this.props.fetchForm(this.props.id);
    this.props.fetchCustomers();
    if (this.props.customerId > 0) {
      this.props.selectCustomer(this.props.customerId);
    }
  }

  render() {
    const { customers, form, selectCustomer, onCustomerCreated } = this.props;

    const showContacts = form.siteIds.length > 0;

    return (
      <form className="ui form">
        <CaseName />
        <CustomerSelector
          customerId={form.customerId && form.customerId.toString()}
          onChange={selectCustomer}
          customerChoice={customers}
          onCustomerCreated={onCustomerCreated}
          errors={form.errors}
        />
        {form.customerId && <SiteSelector />}
        {showContacts && <ContactSelector />}
      </form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customers: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  fetchForm: PropTypes.func.isRequired,
  fetchCustomers: PropTypes.func.isRequired,
  selectCustomer: PropTypes.func.isRequired,
  onCustomerCreated: PropTypes.func.isRequired,
  customerId: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/Page.js